import { TFunction } from 'i18next';
import * as Yup from 'yup';
export const validationSchema = (t: TFunction) =>
  Yup.object({
    adjustQuantity: Yup.string()
      .typeError(t('valid_err_number'))
      .required(t('valid_err_required')),
    transComment: Yup.string().required(t('valid_err_required')),
    // transComment: Yup.string().nullable(),
  });
export type InventoryValidationSchemaType = ReturnType<typeof validationSchema>;
